<div class="tenant-list">
  @for (tenant of tenants; track tenant) {
    <div class="tenant" (click)="navigateTo(tenant.tenantCode)">
      <div class="tenant__detail">
        <h2 class="tenant__name">{{ tenant.name }}</h2>
        <div class="tenant__description" [innerHTML]="tenant.description | safeHtml">
        </div>
      </div>
      <img [src]="getLogo(tenant)" alt="logo" class="tenant__logo">
    </div>
  }
</div>
